export default {
  SET_CONTRACTS (state, contracts) {
    state.contracts = contracts
  },
  SET_CURRENT_EXTRACT (state, extractData) {
    state.currentExtract = extractData
  },
  SET_LOADING_CONTRACT_DETAILS (state, isLoading) {
    state.isLoadingContractDetails = isLoading
  },
  SET_LOADING_STATUS (state, isLoading) {
    state.isLoadingStatus = isLoading
  },
  SET_ERROR (state, error) {
    state.error = error
  },
  CLEAR_CURRENT_EXTRACT (state) {
    state.currentExtract = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/combo_extract/mutations.js